export default {
    getLogedInStatus(state) {
        return state.isLogedIn
    },

    getUser(state) {
        return state.user
    },

    getAccountError(state) {
        return state.accountError
    },

    getUserLoading(state) {
        return state.userLoading
    }
}